import React from 'react';
import { Routes, Route } from 'react-router-dom';

import HomePage from './pages/HomePage';
import ConcessionnairesPage from './pages/ConcessionnairesPage';
import FinancementParticulierPage from './pages/FinancementParticulierPage';
import FinancementCommercialPage from './pages/FinancementCommercialPage';
import CreditAlternatifPage from './pages/CreditAlternatifPage';
import RedressementCreditPage from './pages/RedressementCreditPage';
import SolutionsFlexiblesPage from './pages/SolutionsFlexiblesPage';
import ContactPage from './pages/ContactPage';
import Layout from './components/Layout';
import ErrorPage from './pages/ErrorPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="concessionnaires" element={<ConcessionnairesPage />} />
        <Route path="financement/particulier" element={<FinancementParticulierPage />} />
        <Route path="financement/credit-alternatif" element={<CreditAlternatifPage />} />
        <Route path="financement/commercial" element={<FinancementCommercialPage />} />
        <Route path="financement/redressement-credit" element={<RedressementCreditPage />} />
        <Route path="financement/solutions-flexibles" element={<SolutionsFlexiblesPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Route>
    </Routes>
  );
}

export default App;